export default function ManagedException(message) {
  this.message = message;
  this.stack = new Error().stack;
}
ManagedException.prototype = Object.create(Error.prototype);
ManagedException.prototype.name = "ManagedException";
ManagedException.prototype.isManagedException = true;

export function InsecureContextException(
  message = "common.errorHTTPSRequired"
) {
  this.message = message;
  this.stack = new Error().stack;
}
InsecureContextException.prototype = Object.create(ManagedException.prototype);
InsecureContextException.prototype.name = "InsecureContextException";

export function OutdatedBrowserException(
  message = "common.errorBrowserOutdated"
) {
  this.message = message;
  this.stack = new Error().stack;
}
OutdatedBrowserException.prototype = Object.create(ManagedException.prototype);
OutdatedBrowserException.prototype.name = "OutdatedBrowserException";
